<template>
  <v-app>
    <v-container>
      <v-app-bar app color="#e8991c" height="95" flat>
        <v-row>
          <v-col class="d-flex inner1" cols="6" sm="3">
            <v-img
              alt="TWB Logo"
              class="shrink mr-2"
              contain
              src="@/assets/logo.png"
              transition="scale-transition"
              width="30"
            />
            <v-spacer></v-spacer>

            <!-- Sector selection -->
            <v-select
              v-model="sector"
              :items="sectors"
              label="Sectors"
              class="float-sm-left"
              hide-details
              return-object
              v-on:change="changeSector"
            >
              <template slot="selection" slot-scope="{ item }">{{$i18n.t(item.text)}}</template>
              <template slot="item" slot-scope="{ item }">
                <v-btn class="mx-2" fab dark x-small :color="getColor(item.text)"></v-btn>
                {{$i18n.t(item.text)}}
              </template>
            </v-select>
          </v-col>
          <!-- end of Sector selection -->
          <!-- language selection -->
          <!-- <v-spacer></v-spacer> -->
          <v-col class="d-flex" cols="6" sm="3">
            <v-select
              v-model="value"
              :items="headers"
              multiple
              hide-details
              return-object
              v-on:change="changeItem"
            >
              <template v-slot:label>{{$i18n.t("languages")}}</template>
              <template v-slot:selection="{ item, index }">
                <v-chip small color="rgba(0, 0, 0, 0.54)" v-if="index < 7">
                  <span>{{ item.text }}</span>
                </v-chip>
                <span v-if="index > 6" class="white--text caption">(+{{ value.length - 7 }} others)</span>
              </template>
            </v-select>
          </v-col>
          <!-- <v-spacer></v-spacer> -->
          <!-- end of language selection -->
          <v-col class="d-flex resmedia" cols="6" sm="3">
            <v-text-field
              v-model="search"
              clearable
              prepend-inner-icon="search"
              single-line
              class="mx-3"
              hide-details
              flat
              @change="search"
            >
              <template v-slot:label>{{$i18n.t("search")}}</template>
            </v-text-field>
          </v-col>
          <!-- <v-spacer></v-spacer> -->
          <v-col class="d-flex" col="6" sm="3">
            <v-bottom-sheet v-model="sheet" t>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="#555" dark v-bind="attrs" v-on="on">
                  <v-icon color="orange darken-1" dark v-bind="attrs" v-on="on">translate</v-icon>
                </v-btn>
              </template>
              <v-sheet class="text-center" height="200px">
                <br />
                <span>{{$i18n.t("sw_lang_intro")}}:</span>
                <br />
                <br />

                <v-card class="mx-auto" color="white" width="300px">
                  <v-card-text>
                    <v-select
                      v-model="lang"
                      :items="languages"
                      hide-details
                      return-object
                      chips
                      placeholder="Switch language"
                      v-on:change="changeLang"
                    >
                      <template v-slot:placeholder>{{$i18n.t("sw_lang")}}</template>
                    </v-select>
                  </v-card-text>
                </v-card>
              </v-sheet>
            </v-bottom-sheet>
          </v-col>
          <!-- <v-select
        v-model="lang"
        :items="languages"
        hide-details
        return-object
        chips
        placeholder="Switch language"
        v-on:change="changeLang"
      >
        <template v-slot:placeholder>{{$i18n.t("sw_lang")}}</template>
          </v-select>-->
        </v-row>
      </v-app-bar>
    </v-container>

    <v-main>
      <br/><br/><br/><br/>
	<v-hover v-slot:default="{ hover }">
        <v-data-table
          dense
          light
          :headers="selectedHeaders"
          :expanded="expanded"
          :item-key="id"
          :items="filteredData"
          @click:row="expandRow"
          class="elevation-1"
          :single-expand="true"
          :disable-sort="true"
          :search="search"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-card class="mx-auto" color="#f6f1e9">
                <v-card-title>{{ item.English.term }}</v-card-title>
                <v-card-text>{{ item.English.definition }}</v-card-text>
                <div class="datatable-container"></div>
              </v-card>
            </td>
          </template>

          <template v-slot:item.Sector.term="{ item }">
            <v-chip :color="getColor(item.Sector.term)" dark>{{$i18n.t(item.Sector.term)}}</v-chip>
          </template>
        </v-data-table>
      </v-hover>
    </v-main>
    <v-row justify="center"></v-row>
    <v-footer color="#e8991c" app>
      <span class="white--text">&copy; 2020 Translators without Borders  <v-btn x-small icon outlined href="https://creativecommons.org/licenses/by-nc-sa/3.0/us/" target="_blank"> cc </v-btn></span>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" scrollable width="max-content">
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">info</v-icon>
        </template>
        <v-card>
          <v-card-title>{{this.$i18n.t("info_about_title")}}</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="width: 60%;">
            <About />
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="orange darken-1"
              text
              @click="dialog = false"
            >{{this.$i18n.t("dialog_close")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Removed persistent to close the dialog when clicking outside;For a glossary with multimedia  user will be forced to click the button-->

      <v-dialog v-model="row" scrollable width="max-content">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            {{
            term
            }}
          </v-card-title>
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-icon color="orange darken-1">info</v-icon>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <span class="font-weight-bold">{{this.$i18n.t("dialog_sector")}}:</span>
                <v-spacer></v-spacer>
                <v-chip :color="getColor(sec)" dark>{{$i18n.t(sec)}}</v-chip>

                <v-spacer></v-spacer>
                <span class="font-weight-bold">{{this.$i18n.t("dialog_term")}}:</span>
                <v-spacer></v-spacer>
                {{ term }}

                <v-spacer></v-spacer>
                <span v-if="abbreviation" class="font-weight-bold">{{this.$i18n.t("dialog_abbreviation")}}:</span>
                <v-spacer></v-spacer>
                {{ abbreviation }}

		
		<v-spacer></v-spacer>
                <span v-if="partofspeech" class="font-weight-bold">{{this.$i18n.t("dialog_partofspeech")}}:</span>
                <v-spacer></v-spacer>
                {{ partofspeech }}

		 <v-spacer></v-spacer>
                <span v-if="alternative" class="font-weight-bold">{{this.$i18n.t("dialog_alternative")}}:</span>
                <v-spacer></v-spacer>
                {{ alternative }}


		 <v-spacer></v-spacer>
                <span v-if="definition" class="font-weight-bold">{{this.$i18n.t("dialog_definition")}}:</span>
                <v-spacer></v-spacer>
                {{ definition }}


                <v-spacer></v-spacer>
                <span v-if="source" class="font-weight-bold">{{this.$i18n.t("dialog_source")}}:</span>
                <v-spacer></v-spacer>
                {{ source }}

              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="picturecount">
              <v-expansion-panel-header>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-badge color="grey" :content="picturecount" inline>
                      <v-icon color="orange darken-1" dark v-bind="attrs" v-on="on">mdi-folder-image</v-icon>
                    </v-badge>
                  </template>
                  <span>{{this.$i18n.t("dialog_tooltip_img")}}</span>
                </v-tooltip>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-spacer></v-spacer>
                <v-carousel v-if="picture">
                  <v-carousel-item
                    v-for="(item, i) in picture"
                    :key="i"
                    :src="'./library/pictures/' + item.url"
                    reverse-transition="fade-transition"
                    transition="fade-transition"
                  ></v-carousel-item>
                </v-carousel>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="vidcount">
              <v-expansion-panel-header>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-badge color="grey" :content="vidcount" inline>
                      <v-icon color="orange darken-1" dark v-bind="attrs" v-on="on">mdi-video</v-icon>
                    </v-badge>
                  </template>
                  <span>{{this.$i18n.t("dialog_tooltip_vid")}}</span>
                </v-tooltip>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-spacer></v-spacer>
                <template>
                  <span v-for="(value, index) in vid" v-bind:key="index">
                    <div class="player-container">
                      <vue-core-video-player
                        :src="'./library/videos/' + value.url"
                        :title="value.title"
                        :autoplay="false"
                      ></vue-core-video-player>
                    </div>
                  </span>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="audiocount">
              <v-expansion-panel-header>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-badge color="grey" :content="audiocount" inline>
                      <v-icon color="orange darken-1" dark v-bind="attrs" v-on="on">mdi-volume-high</v-icon>
                    </v-badge>
                  </template>
                  <span>{{this.$i18n.t("dialog_tooltip_audio")}}</span>
                </v-tooltip>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-spacer></v-spacer>
                <v-carousel :show-arrows="false">
                  <v-carousel-item v-for="(value, index) in audio" v-bind:key="index">
                    <v-divider></v-divider>
                    <v-container class="grey lighten-5">
                      <v-chip class="text-center .col-6 .col-md-4">
                        <span class="white--text">{{ index }}/{{ audiocount }}</span>
                      </v-chip>
                      <v-spacer></v-spacer>
                      <v-row>
                        <v-col>
                          <span class="font-weight-bold text-center black--text">Language:</span>
                          <v-spacer></v-spacer>
                          <span class="font-weight-regular black--text">
                            {{
                            value.lang
                            }}
                          </span>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <span class="font-weight-bold text-center black--text">Term:</span>
                          <v-spacer></v-spacer>
                          <span class="font-weight-regular black--text">
                            {{
                            value.definition
                            }}
                          </span>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-spacer></v-spacer>

                      <v-row>
                        <v-col>
                          <av-waveform
                            audio-class="audioclass"
                            :audio-src="'./library/'+ value.url"
                            :noplayed-line-color="waveformcolor"
                          ></av-waveform>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-carousel-item>
                </v-carousel>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="orange darken-1"
              text
              @click="row = false"
            >{{this.$i18n.t("dialog_close")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <span :class="onlineDot"></span>
    </v-footer>
  </v-app>
</template>

<script>
import About from "@/views/About.vue";
import json from "@/assets/data/glossary.json";

export default {
  name: "App",
  components: { About },
  data() {
    return {
      id: "",
      publicPath: process.env.BASE_URL,
      glossary: json,
      search: "",
      value: [
        { text: "Sector", value: "Sector.term" }
        /*{ text: "English", value: "English.term" }*/
      ],
      expanded: [],
      selectedHeaders: [],
      dialog: false,
      row: false,
      term: "",
      definition: "",
      abbreviation: "",
      partofspeech: "",
      alternative: "",
      source: "",
      library: "",
      picture: "",
      vid: "",
      audio: "",
      audiocount: "",
      picturecount: "",
      vidcount: "",
      sector: "",
      sec: "",
      waveformcolor: "#fb8c00",
      sectorSelect: "",

 sectors: [
{ text: "sector_all", value: "All" },
{ text: "Covid-19", value: "Covid-19" },
{ text: "Education", value: "Education" },
{ text: "Emergency", value: "Emergency" },
{ text: "Gender", value: "Gender" },
{ text: "Health", value: "Health" },
{ text: "Nutrition", value: "Nutrition" },
{ text: "Protection", value: "Protection" },
{ text: "Return and Relocation", value: "Return and Relocation" },
{ text: "Wash", value: "Wash" }
      ],
      headers: [
        { text: "Sectors", value: "Sector.term", disabled: true },
        { text: "English", value: "English.term" },
        { text: "Bangladesh", value: "Bangladesh.term" },
        { text: "Chittagonian", value: "Chittagonian.term" },
        { text: "Myanmar", value: "Myanmar.term" },
        { text: "Rohingya", value: "Rohingya.term" }
      ],
      panel: 0,
      lang: "",
      languages: [
        { text: "English", value: "en" }
      ],
      sheet: false,
      onLine: navigator.onLine,
      onlineDot: navigator.onLine === true ? "online" : "offline"
    };
  },


  methods: {
    filter(value, search, item) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value
          .toString()
          .toLocaleLowerCase()
          .indexOf(search.toLocaleLowerCase()) !== -1
      );
    },

    expandRow(item) {
      //Get the onject entry based on user click
      var data = json.glossary;
      var s = item.id;
      var fil = [];

      var term = [];

      fil = data.filter(function(i, item) {
        return i.id == s;
      });

      //Get objects in the selected term
      var term = event.target.innerHTML;
      function objfilter(object, result, key, value) {
        if (object.hasOwnProperty(key) && object[key] == value)
          result.push(object);
	
        for (var i = 0; i < Object.keys(object).length; i++) {
          if (typeof object[Object.keys(object)[i]] == "object") {
            objfilter(object[Object.keys(object)[i]], result, key, value);
          }
        }
      }
      var result = [];
      objfilter(fil, result, "term", term);

      var resource = result[0];
      this.term = resource.term;
      this.abbreviation = resource.abbreviation;
      this.partofspeech = resource.partofspeech;
      this.definition = resource.definition;
      this.alternative = resource.alternative;
      this.source = resource.source;
      this.sec = item.Sector.term;
      this.audio = resource.library.audio;
      this.picture = resource.library.picture;
      this.vid = resource.library.video;
      this.library = resource.library;

      //Counts on the tabs
      //console.log(this.$i18n.t("welcomeMsg"));
      //console.log(this.$vuetify.lang.current);
      //console.log(this.$i18n.locale);
      
      this.audiocount = Object.keys(resource.library.audio).length;
      this.picturecount = Object.keys(resource.library.picture).length;
      this.vidcount = Object.keys(resource.library.video).length;
      this.row = true;
    },
    changeSector(event) {
      this.sectorSelect = event.value;
    },
    changeLang(event) {
      this.$i18n.locale = event.value;
      this.$vuetify.lang.current = event.value;
      this.sheet = !this.sheet;
      this.json = null;
      console.log(json);
    },
    changeItem(event) {
      var langs = [];

      for (var i = 0; i < event.length; i++) {
        langs.push(event[i].text);
      }

      //Google Analytics
      this.$gtag.event("Selected Language Combinations", {
        event_category: "Lang",
        event_label: langs,
        value: "test offline"
        // event_label: "Language(s)",
        //value: langs
      });
    },
    updateOnlineStatus(e) {
      const { type } = e;

      this.onLine = type === "online";
      this.onlineDot = type;
    },

    getColor(item) {
      if (item == "Covid-19") return "red";
      else if (item == "Health") return "orange darken-1";
      else if (item == "Emergency") return "red darken-2";
      else if (item == "Education") return "blue";
	else if (item == "Protection") return "green";
      else return "";
    }
  },
  watch: {
    value(val) {
      this.selectedHeaders = val;
    },
    onLine(val) {
      if (val) {
        this.showBackOnline = true;
      } else {
        this.showBackOnline = false;
      }
    },
    row(val) {
      if (!val) {
	//Reset the audio when modal is closed
        this.audio = "";
        //Close the panel
        this.panel = 0;
        //Pause the video when modal is closed
        var video = document.getElementsByTagName("video")[0];

        //Prevent throwing an error when the video has not been played
        if (typeof video !== "undefined") {
          video.addEventListener(
            "seeking",
            function() {
              if (video.paused) {
                video.pause();
              } else {
                video.pause();
              }
            },
            false
          );

          video.currentTime = 0;
        }

        //Pause the audio when modal is closed
        /*
        var audio = document.getElementsByTagName("audio")[0];
        audio.addEventListener(
          "seeking",
          function() {
            if (!audio.paused) {
              audio.pause();
            } else {
              audio.pause();
            }
          },
          false
        );

        audio.currentTime = 0;
        */
      }
    }
  },
  computed: {
    //Sector Dropdown - Filter data based on selected sector
    filteredData() {
      if (this.sectorSelect === "All" || this.sectorSelect == "") {
        return json.glossary;
      } else {
        var data = json.glossary;
        var s = this.sectorSelect;

        this.filtered_glos = data.filter(function(i, item) {
          return i.Sector.term == s;
        });

        return this.filtered_glos;
      }
    }
  },
  created() {
    this.selectedHeaders = this.headers;
  },
  mounted() {
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  }
};
</script>
<style>
tbody tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.1) !important;
  cursor: pointer;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05) !important;
  cursor: pointer;
}
.v-data-table__mobile-row__header {
  font-weight: 300 !important;
}
.v-data-table__mobile-row__cell {
  font-weight: 500;
}
.v-data-table-header-mobile {
  display: none !important;
}
.v-data-footer__pagination {
  margin-right: 1px !important;
  margin-left: 1px !important;
}
.v-application--is-ltr .v-data-footer__select .v-select {
  margin-top: 1px !important;
  margin-bottom: 5px !important;
}
.online {
  height: 10px;
  width: 10px;
  background-color: #228b22;
  border-radius: 50%;
  display: inline-block;
}
.offline {
  height: 10px;
  width: 10px;
  background-color: #777;
  border-radius: 50%;
  display: inline-block;
}
</style>
